import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  CLIENT_CARD_PATH,
  LEAD_CARD_PATH,
  RECORDS_PATH,
  USERS_PATH,
} from '@app/constants';
import { useTaskListContext } from '@app/providers/TaskListProvider';

// Значения EntityType, которые реально отдаёт бэк (см. свагер
// CRM.Dots.FrontendEvents.ModelNotification: "Lead, Client, Record,
// Employee..." — открытый список, а не закрытый enum), сопоставленные с уже
// существующими в приложении маршрутами/модалками для тех же типов сущностей
// (см. src/utils/handleHistoryElementHeaderLinks.tsx).
const LEAD_ENTITY_TYPE = 'Lead';
const CLIENT_ENTITY_TYPE = 'Client';
const USER_ENTITY_TYPE = 'User';
const CRM_TASK_ENTITY_TYPE = 'CrmTask';
const RECORD_ENTITY_TYPE = 'Record';
// Звонки (CallIncoming/CallMissed) не имеют собственной страницы на фронте —
// EntityId в пейлоаде совпадает с ClientId (см. PayloadJson), поэтому ведём
// на карточку клиента.
const CALL_ENTITY_TYPE = 'Call';
// Реальный EntityType для OnlineRecordCreated/OnlineRecordStatusChanged —
// буквально "OnlineRecord" (проверено на живом пейлоаде), а не "Record" из
// свагера. Отдельной сущности/страницы для онлайн-записи на фронте нет (см.
// src/utils/handleHistoryElementHeaderLinks.tsx) — ведём туда же, куда и
// обычную запись.
const ONLINE_RECORD_ENTITY_TYPE = 'OnlineRecord';

export const useNotificationClickHandler = () => {
  const navigate = useNavigate();
  const { openPreviewTaskModal } = useTaskListContext();

  return useCallback(
    (entityType: string | null, entityId: number | null) => {
      if (!entityType || !entityId) return;

      switch (entityType) {
        case LEAD_ENTITY_TYPE:
          navigate(`${LEAD_CARD_PATH}?leadId=${entityId}`);
          break;
        case CLIENT_ENTITY_TYPE:
        case CALL_ENTITY_TYPE:
          navigate(`${CLIENT_CARD_PATH}?id=${entityId}`);
          break;
        case USER_ENTITY_TYPE:
          navigate(`${USERS_PATH}/edit/?id=${entityId}&key=1`);
          break;
        case CRM_TASK_ENTITY_TYPE:
          openPreviewTaskModal(entityId);
          break;
        case RECORD_ENTITY_TYPE:
        case ONLINE_RECORD_ENTITY_TYPE:
          navigate(`${RECORDS_PATH}?recordId=${entityId}`);
          break;
        default:
          // Неизвестный/ещё не поддержанный на фронте тип сущности —
          // тост остаётся кликабельным, но просто закрывается без перехода.
          break;
      }
    },
    [navigate, openPreviewTaskModal]
  );
};
